// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3eUQ1","unreadBadge":"styles_unreadBadge__tV-Wf","modalContent":"styles_modalContent__2orrJ","modal":"styles_modal__8TqFq"};